export default "__VITE_ASSET__BrNqzBON__"